import React from "react";
import { Modal, Form } from 'react-bootstrap';
import * as EmailValidator from 'email-validator';
import swal from 'sweetalert';
import { EnviarEmailSenha, Consult } from '../../data/Service/UserService';
import '../../assets/css/style.css';
import { Redirect } from "react-router-dom";

class LoginModal extends React.Component {

  constructor(){
    super();
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleEmailOnChange = this.handleEmailOnChange.bind(this);
    this.handleSenhaOnChange = this.handleSenhaOnChange.bind(this);
    this.handleEmailForgotOnChange = this.handleEmailForgotOnChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.handleSubmitForgot = this.handleSubmitForgot.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.showRecovery = this.showRecovery.bind(this);
    this.showLogin = this.showLogin.bind(this);

    this.state = {
        show: false,
        emailModal: '',
        senhaModal: '',
        emailForgot: '',
        token: '',
        email: '',
        mode: 'login',
        isSubmitting: false,
        isAuthenticated: false
    };
  }

  showRecovery(){
    this.setState({ mode: 'recovery', emailForgot: this.state.emailModal });
  }

  showLogin(){
    this.setState({ mode: 'login' });
  }

  handleShow() {
    this.setState({ show: true, mode: 'login', isSubmitting: false });
  }

  handleClose(){
    this.setState({ show: false, mode: 'login', isSubmitting: false });
  }

  handleEmailOnChange(e){           
    this.setState({emailModal: e.target.value});
  }

  handleEmailForgotOnChange(e){           
    this.setState({emailForgot: e.target.value});
  }

  handleSenhaOnChange(e){           
    this.setState({senhaModal: e.target.value});
  }

  handleLogin(){
    // Atualize o estado de autenticação sem recarregar a página
    this.setState({ isAuthenticated: true });
  }

  async handleSubmitForgot(e){
    e.preventDefault();
    const email = this.state.emailForgot.trim().toLowerCase();

    if(!EmailValidator.validate(email)) {
      swal('Informe um e-mail válido.','','error');
      return;
    }

    this.setState({ isSubmitting: true });
    try {
      const response = await EnviarEmailSenha(email);
      if (!response || response.Ok !== true) {
        throw new Error(response && response.Mensagem);
      }
      await swal('Verifique seu e-mail', 'Se houver uma conta cadastrada, enviaremos as instruções de acesso.', 'success');
      this.setState({ mode: 'login', emailModal: email, emailForgot: '' });
    } catch (error) {
      swal('Não foi possível enviar agora', 'Tente novamente em alguns instantes.', 'error');
    } finally {
      this.setState({ isSubmitting: false });
    }
  }

  async onSubmit(e){
    e.preventDefault();

    const user = {
      emailModal: this.state.emailModal,
      senhaModal: this.state.senhaModal
    };

    if(user.emailModal === '' && user.senhaModal === ''){
      swal('Favor informar o seu E-MAIL e SENHA!','','error');
    } else if(user.emailModal === ''){
      swal('Favor informar o seu E-MAIL!','','error');
    } else if(user.senhaModal === ''){
      swal('Favor informar o sua SENHA!','','error');
    } else if (!EmailValidator.validate(user.emailModal)) {
      swal('Informe um e-mail válido.','','error');
    } else {
      this.setState({ isSubmitting: true });
      try {
        const res = await Consult(user.emailModal, user.senhaModal);
          if(res.Token === undefined || res.Token === null || res.Token === '' ){
            swal('Usuário ou senha inválido(s). Caso não se recorde de sua senha, informar seu e-mail na opção Esqueci Minha Senha.','','info');
          } else {
            localStorage.setItem('token', res.Token);
            localStorage.setItem('senhaModal', user.senhaModal);
            localStorage.setItem('email', user.emailModal);

            this.setState({ 
              senhaModal: user.senhaModal,
              token: res.Token,
              isAuthenticated: true,
              show: false
            });
          }
      } catch (error) {
        swal('Não foi possível acessar', 'Verifique sua conexão e tente novamente.', 'error');
      } finally {
        this.setState({ isSubmitting: false });
      }
    }
  }

  render(){ 
    const { isAuthenticated } = this.state;

    if (isAuthenticated) {
      console.log("wntrou");
      return <Redirect to='/arealogada' />;
    }

    return (
      <div>
        <Modal 
          show={this.state.show}
          onHide={this.handleClose}
          centered
          dialogClassName="login-dialog"
          contentClassName="login-modal-content"
        >
          <div className="login-shell">
            <button type="button" className="login-close" onClick={this.handleClose} aria-label="Fechar">X</button>
            <div className="login-brand" aria-hidden="true">PT</div>
            <div className="login-panel" key={this.state.mode}>
              {this.state.mode === 'login' ? (
                <Form onSubmit={this.onSubmit} className="login-form">
                  <header className="login-header">
                    <span className="login-eyebrow">ÁREA DO ALUNO</span>
                    <h2>LOGIN</h2>
                    <p>Acesse suas aulas e conteúdos exclusivos.</p>
                  </header>
                  <div className="login-field">
                    <label htmlFor="login-email">E-mail</label>
                    <input 
                      id="login-email"
                      type="email"
                      name="emailModal" 
                      className="form-control"
                      placeholder="seu@email.com"
                      autoComplete="email"
                      value={this.state.emailModal}
                      onChange={this.handleEmailOnChange}
                      onInvalid={event => event.target.setCustomValidity(event.target.validity.valueMissing ? 'Campo obrigatório' : 'Informe um e-mail válido')}
                      onInput={event => event.target.setCustomValidity('')}
                      required />
                  </div>
                  <div className="login-field">
                    <label htmlFor="login-password">Senha</label>
                    <input 
                      id="login-password"
                      type="password"
                      name="senhaModal" 
                      className="form-control"
                      placeholder="Sua senha"
                      autoComplete="current-password"
                      value={this.state.senhaModal}
                      onChange={this.handleSenhaOnChange}
                      onInvalid={event => event.target.setCustomValidity('Campo obrigatório')}
                      onInput={event => event.target.setCustomValidity('')}
                      required />
                  </div>
                  <button className="login-primary" type="submit" disabled={this.state.isSubmitting}>
                    {this.state.isSubmitting ? 'ENTRANDO...' : 'ACESSAR'}
                  </button>
                  <button className="login-link" type="button" onClick={this.showRecovery}>
                    Esqueci minha senha
                  </button>
                </Form>
              ) : (
                <Form onSubmit={this.handleSubmitForgot} className="login-form">
                  <header className="login-header">
                    <span className="login-eyebrow">RECUPERAR ACESSO</span>
                    <h2>NOVA SENHA</h2>
                    <p>Informe seu e-mail para receber as instruções.</p>
                  </header>
                  <div className="login-field">
                    <label htmlFor="recovery-email">E-mail</label>
                    <input
                      id="recovery-email"
                      type="email"
                      name="emailForgot"
                      className="form-control"
                      placeholder="seu@email.com"
                      autoComplete="email"
                      autoFocus
                      value={this.state.emailForgot}
                      onChange={this.handleEmailForgotOnChange}
                      onInvalid={event => event.target.setCustomValidity(event.target.validity.valueMissing ? 'Campo obrigatório' : 'Informe um e-mail válido')}
                      onInput={event => event.target.setCustomValidity('')}
                      required />
                  </div>
                  <button className="login-primary" type="submit" disabled={this.state.isSubmitting}>
                    {this.state.isSubmitting ? 'ENVIANDO...' : 'ENVIAR INSTRUÇÕES'}
                  </button>
                  <button className="login-link" type="button" onClick={this.showLogin}>
                    Voltar ao login
                  </button>
                </Form>
              )}
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default LoginModal;
